import React, { useLayoutEffect, useRef } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Animated,
  Easing,
} from "react-native";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
  scaleSize,
} from "../../../Utils/responsive";
import "../../../App.scss";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import NoSinsToken from "../../../assets/svg/Token-NoSins.svg";
import PeoplePlanetToken from "../../../assets/svg/Token-PeoplePlanet.svg";
import PlanetToken from "../../../assets/svg/Token-Planet.svg";
import PositiveImpactToken from "../../../assets/svg/Token-PositiveImpact.svg";
import PeopleToken from "../../../assets/svg/Token-People.svg";
import CarbonNeutralToken from "../../../assets/svg/Token-CarbonNeutral.svg";
import AllToken from "../../../assets/svg/Token-All.svg";

const actualWidth = Dimensions.get("screen").width;
// Use the actual viewport (window) — NOT screen, which is the physical monitor
// and does not change when the browser window is resized.
const viewportWidth = Dimensions.get("window").width;
const viewportHeight = Dimensions.get("window").height;
// Tighten vertical spacing on short viewports so the centered column fits
// without clipping the top/bottom content on lower-resolution screens.
const isShort = viewportHeight < 900;
// Mirror the width breakpoints of --module-detail-font-size (32 / 24 / 20)
// while also scaling down on short viewports, which the CSS variable's
// width-only media queries don't handle.
const detailFontSize = scaleSize(
  viewportWidth > 750 ? 32 : viewportWidth > 400 ? 24 : 20
);
const Index = (props) => {
  const introAnimation = useRef(new Animated.Value(actualWidth)).current;
  useLayoutEffect(() => {
    Animated.timing(introAnimation, {
      toValue: 0,
      duration: 500,
      useNativeDriver: false,
      easing: Easing.linear,
    }).start();
  }, []);

  const goBack = () => {
    props.pageTwo();
    props.setModuleIndex((moduleIndex) => moduleIndex - 1);
    props.resultContext.resetPreviousModuleResult(props.moduleObject.moduleid);
  };
  const getDeviceType = () => {
    const ua = navigator.userAgent;

    // Patterns for mobile and tablet detection
    const isMobile = /iPhone|iPad|iPod|Android/i.test(ua);
    const isTablet = /iPad|Android/i.test(ua) && !/Mobile/i.test(ua);
    if (isMobile) {
      if (isTablet) {
        return "tablet";
      }
      return "mobile";
    }
    return "desktop";
  };
  return (
    <Animated.View
      style={[styles.content, { transform: [{ translateX: introAnimation }] }]}
    >
      <TouchableOpacity style={styles.backButton} onPress={goBack}>
        <ArrowBackIcon style={{ height: 24, width: 24 }} htmlColor="#575f69" />
      </TouchableOpacity>
      <Text style={styles.customText}>
        You will be shown a series of tokens representing different values.
      </Text>
      <View style={styles.ballContainer}>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <View style={styles.balls}>
            <img
              src={NoSinsToken}
              alt=""
              style={{
                width: scaleSize(actualWidth > 1000 ? 62 : actualWidth > 400 ? 62 : 31),
                height: scaleSize(actualWidth > 1000 ? 62 : actualWidth > 400 ? 62 : 31),
                objectFit: "contain",
              }}
            />
          </View>
          <View style={styles.balls}>
            <img
              alt=""
              src={PeoplePlanetToken}
              style={{
                width: scaleSize(actualWidth > 1000 ? 62 : actualWidth > 400 ? 62 : 31),
                height: scaleSize(actualWidth > 1000 ? 62 : actualWidth > 400 ? 62 : 31),
                objectFit: "contain",
              }}
            />
          </View>
        </View>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <View style={styles.balls}>
            <img
              alt=""
              src={PlanetToken}
              style={{
                width: scaleSize(actualWidth > 1000 ? 62 : actualWidth > 400 ? 62 : 31),
                height: scaleSize(actualWidth > 1000 ? 62 : actualWidth > 400 ? 62 : 31),
                objectFit: "contain",
              }}
            />
          </View>
          <View style={styles.balls}>
            <img
              src={PositiveImpactToken}
              alt=""
              style={{
                width: scaleSize(actualWidth > 1000 ? 62 : actualWidth > 400 ? 62 : 31),
                height: scaleSize(actualWidth > 1000 ? 62 : actualWidth > 400 ? 62 : 31),
                objectFit: "contain",
              }}
            />
          </View>
          <View style={styles.balls}>
            <img
              src={PeopleToken}
              alt=""
              style={{
                width: scaleSize(actualWidth > 1000 ? 62 : actualWidth > 400 ? 62 : 31),
                height: scaleSize(actualWidth > 1000 ? 62 : actualWidth > 400 ? 62 : 31),
                objectFit: "contain",
              }}
            />
          </View>
        </View>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <View style={styles.balls}>
            <img
              src={CarbonNeutralToken}
              alt=""
              style={{
                width: scaleSize(actualWidth > 1000 ? 62 : actualWidth > 400 ? 62 : 31),
                height: scaleSize(actualWidth > 1000 ? 62 : actualWidth > 400 ? 62 : 31),
                objectFit: "contain",
              }}
            />
          </View>
          <View style={styles.balls}>
            <img
              src={AllToken}
              alt=""
              style={{
                width: scaleSize(actualWidth > 1000 ? 62 : actualWidth > 400 ? 62 : 31),
                height: scaleSize(actualWidth > 1000 ? 62 : actualWidth > 400 ? 62 : 31),
                objectFit: "contain",
              }}
            />
          </View>
        </View>
      </View>
      <Text style={styles.customText}>
        {getDeviceType() === "desktop" ? "Click" : "Tap"} the tokens that
        reflect your investment values so that we know how best to invest your
        money to suit your values.
      </Text>
      <View style={styles.line} />
      <TouchableOpacity style={styles.button} onPress={props.pageThree}>
        <Text style={styles.buttontext}>Continue</Text>
      </TouchableOpacity>
      <TouchableOpacity style={styles.goBack} onPress={goBack}>
        <Text style={styles.goBackText}>go back</Text>
      </TouchableOpacity>
    </Animated.View>
  );
};
export default Index;
const styles = StyleSheet.create({
  content: {
    height: "100vh",
    width: "100vw",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },

  customText: {
    position: "relative",
    width: "75%",
    fontSize: detailFontSize,
    textAlign: "center",
    color: "var(--text-color-alternate)",
    marginBottom: isShort ? 14 : 28,
    fontWeight: "var(--font-weight-light)",
    letterSpacing: "var(--module-detail-letter-spacing)",
  },
  button: {
    backgroundColor: "var(--button-background-color-default)",
    justifyContent: "center",
    borderRadius: 2,
    marginBottom: isShort ? 14 : 28,
    elevation: 2,
    shadowColor: "rgba(0, 0, 0, 0.15)",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 2,
  },
  buttontext: {
    color: "#ffffff",
    fontWeight: "var(--font-weight-bold)",
    fontSize: "var(--button-font-size)",
    textAlign: "center",
    letterSpacing: "var(--button-letter-spacing)",
    textTransform: "uppercase",
    textShadowColor: "rgba(0, 0, 0, 0.5)",
    textShadowOffset: { width: 0, height: 1 },
    paddingLeft: "var(--button-padding-left)",
    paddingRight: "var(--button-padding-right)",
    paddingTop: "var(--button-padding-top)",
    paddingBottom: "var(--button-padding-bottom)",
  },
  line: {
    width:
      actualWidth > 1000
        ? wp("35%")
        : actualWidth > 400
        ? wp("45%")
        : wp("55%"),
    height: 1,
    backgroundColor: "#d4d4d4",
    marginBottom: isShort ? hp("2%") : hp("4%"),
  },
  heading: {
    fontSize: actualWidth > 1000 ? 48 : actualWidth > 400 ? 32 : 16,
    textAlign: "center",
    color: "var(--text-color-default)",
    marginBottom: hp("3%"),
    fontWeight: "var(--font-weight-light)",
    letterSpacing: 4.8,
  },
  goBack: {
    backgroundColor: "transparent",
    width: 118,
    height: 48,
    marginBottom: isShort ? hp("1.5%") : hp("3%"),
    justifyContent: "center",
  },
  goBackText: {
    color: "var(--text-color-default)",
    fontWeight: "var(--font-weight-bold)",
    fontSize: actualWidth > 400 ? 16 : 12,
    textAlign: "center",
    letterSpacing: actualWidth > 400 ? 1.6 : 1.2,
    textTransform: "uppercase",
  },
  ballContainer: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: isShort ? hp("1.5%") : hp("3%"),
  },
  balls: {
    width: scaleSize(actualWidth > 1000 ? 62 : actualWidth > 400 ? 62 : 31),
    height: scaleSize(actualWidth > 1000 ? 62 : actualWidth > 400 ? 62 : 31),
    borderRadius: scaleSize(actualWidth > 1000 ? 31 : actualWidth > 400 ? 31 : 15),
    elevation: 4,
    backgroundColor: "transparent",
    alignItems: "center",
    justifyContent: "center",
    marginVertical: actualWidth > 400 ? 10 : 5,
    marginHorizontal: actualWidth > 400 ? 20 : 10,
  },
  backButton: {
    height: 24,
    width: 24,
    borderRadius: 12,
    backgroundColor: "transparent",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: actualWidth > 500 ? -20 : -15,
    left: 10,
  },
});
